module.exports = __webpack_public_path__ + "img/ru.d3ee2c53.svg";